module.exports = __webpack_public_path__ + "img/brand.367ea27f.svg";